import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { SelectFromConstant } from '../../../components/dropdown-select/SelectFromConstant';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';
import { profileTypes } from '../../../config/constants/userConstants';

const selectableUsers = [profileTypes.TECHNICIAN.id, profileTypes.INTERESTED.id, profileTypes.OPERATOR.id];

export const SelectUserProfile = ({ value, onChange, multiple , disabled}) => {
  const { translate: t } = useDictionaryTranslation();
  const options = useMemo(() => {
    return Object.values(profileTypes)
      .filter((option) => selectableUsers.includes(option.id))
      .map((option) => ({ ...option, label: t(option.name), value: option.id }));
  }, [t]);

  const selectedValue = value && options.find((v) => v.value === value.value);

  return (
    <SelectFromConstant
      value={selectedValue}
      onChange={onChange}
      constantObject={options}
      placeholderText={t('selectTypeUserPlaceholder')}
      multiple={multiple}
      disabled={disabled}
    />
  );
};

SelectUserProfile.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
};
